import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {IErrorResponse, IRootState} from "../../../../types";
import {
    deletedRestoreStudyPayment,
    deletedStudyPayment,
    setStudyPayment, setStudyPaymentRestore,
    setStudyPaymentTypes,
    updateStudyPayment
} from "./studyPaymentSlice";
import {IStudyPaymentCreate, IStudyPaymentPayload} from "../types";




const GetStudyPaymentTypes = createAsyncThunk(
    "get/study/payment/types",
    async (_, {dispatch, rejectWithValue,getState}) => {
        try {
            const response = await request.get("/study-payment-types");
            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage
            dispatch(setStudyPaymentTypes({data:response.data,defaultLanguage}));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const GetStudyPayment = createAsyncThunk(
    "get/study/payment",
    async (_, {dispatch, rejectWithValue}) => {
        try {
            const response = await request.get("/study-payment-options");
            dispatch(setStudyPayment({data:response.data}));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const CreateStudyPayment = createAsyncThunk(
    "create/study/payment",
    async (data: IStudyPaymentCreate, { rejectWithValue}) => {
        try {
            const response = await request.post("/study-payment-options", data);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const EditStudyPayment = createAsyncThunk(
    "edit/study/payment",
    async (data: IStudyPaymentPayload, {dispatch, rejectWithValue}) => {
        try {

            const response = await request.put(`/study-payment-options/${data.id}`,data);
            dispatch(updateStudyPayment(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);







const DeleteStudyPayment = createAsyncThunk(
    "delete/study/payment",
    async ( id : number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/study-payment-options/${id}`);

            dispatch(deletedStudyPayment(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteStudyPayment = createAsyncThunk(
    "get/delete/study/payment",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/study-payment-options/deleted-items`);

            dispatch(setStudyPaymentRestore(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);



const RestoreDeleteStudyPayment= createAsyncThunk(
    "restore/delete/study/payment",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/study-payment-options/restore/${id}`);
            dispatch(deletedRestoreStudyPayment(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);




export{
    GetStudyPaymentTypes,
    GetStudyPayment,
    CreateStudyPayment,
    EditStudyPayment,
    DeleteStudyPayment,
    GetDeleteStudyPayment,
    RestoreDeleteStudyPayment
}